import React from "react";
import { Controller } from "react-hook-form";
import { StyledSwitch } from "./CustomSwitch";
import { Switch } from "@mui/material";

interface ISwitch {
  control: any;
  name: string;
  props?: any;
  label?: string;
  icon?: React.ReactElement;
  horizon?: boolean;
}
const Index: React.FC<ISwitch> = ({
  control,
  name,
  props,
  label,
  icon,
  horizon = false,
}) => {
  return (
    <Controller
      render={({ field }) => (
        <StyledSwitch horizon={horizon}>
          <label>
            {label && label}
            {icon && icon}
          </label>
          <Switch
            {...field}
            id={name}
            onChange={(e) => {
              field.onChange(e);
            }}
            checked={field.value}
          />
        </StyledSwitch>
      )}
      name={name}
      defaultValue={false}
      control={control}
    />
  );
};

export default Index;
